import {
    ChangeDetectorRef,
    Component,
    computed,
    EventEmitter,
    inject,
    Input,
    model,
    Output,
    signal,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
    CalendarView,
    CalendarEvent,
    CalendarMonthViewBeforeRenderEvent,
    CalendarWeekViewBeforeRenderEvent,
    CalendarCommonModule,
    CalendarMonthModule,
} from 'angular-calendar';
import { ViewPeriod } from 'calendar-utils';
import { RRule } from 'rrule';
import { Observable, Subject } from 'rxjs';
import { DayDialogComponent } from './day-dialog/day-dialog.component';
import { TimeOffManagerDialogComponent } from './add-time-off-dialog/time-off-mananger-dialog.component';
import { TimeOffService } from 'src/app/services/time-off.service';
import { TimeOff } from 'src/app/models/timeOff.model';
import { getHolidays, Holidays } from 'date-fns-holiday-us';
import { DatePipe, NgIf, NgFor, CommonModule } from '@angular/common';
import {
    DayOfWeekAsNumber,
    DayOfWeekAsString,
} from 'src/app/enums/day-of-week.enum.ts';
import { MatButtonModule } from '@angular/material/button';
import { endOfDay, startOfDay } from 'date-fns';
import { MatCardModule } from '@angular/material/card';
import { COUNT, CURRENTDATE } from '../../constants/queryParamConstants';
import { ThemeService } from 'src/app/services/theme.service';
import {
    BIWEEKLY,
    ENDOFDAYHOURS,
    ENDOFDAYMINUTES,
    ENDOFDAYSECONDS,
    EVENTLIMIT,
    NEXT,
    NOTFOUND,
    PREVIOUS,
    STARTOFDAYTIME,
} from 'src/app/constants/calendarConstants';
import { CalendarEventExtension } from 'src/app/interfaces/calendar-event-extension.interface';
import { RecurringEvent } from 'src/app/interfaces/recurring-Event.interface';
import { Month } from 'src/app/enums/month.enum';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import {
    MatAutocompleteModule,
    MatAutocompleteSelectedEvent,
    MatOption,
} from '@angular/material/autocomplete';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { User } from 'src/app/models/User';
import { COUNT_ALL } from 'src/app/constants/searchConstants';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UserService } from 'src/app/services/user.service';
import { Holiday } from 'src/app/interfaces/holiday.interface';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    providers: [DatePipe],
    imports: [
        MatButtonModule,
        MatButtonModule,
        CalendarCommonModule,
        CalendarMonthModule,
        NgIf,
        NgFor,
        MatCardModule,
        CommonModule,
        MatFormField,
        MatLabel,
        MatChipsModule,
        MatIcon,
        MatAutocompleteModule,
        MatOption,
        FormsModule,
    ],
})
export class CalendarComponent {
    @Input() parentDate: Date;
    @Output() dateChanged = new EventEmitter<Date>();

    view: CalendarView = CalendarView.Month;
    CalendarView = CalendarView;
    viewDate: Date = new Date();
    refresh = new Subject<void>();
    activeDayIsOpen = false;
    viewRender:
        | CalendarMonthViewBeforeRenderEvent
        | CalendarWeekViewBeforeRenderEvent;

    allHolidays: Holidays;
    calendarEvents: CalendarEventExtension[] = [];

    psHolidays = [
        {
            userName: '',
            format: 'newYearsDay',
            title: 'PSS HOLIDAY - New Years Day',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
        {
            userName: '',
            format: 'memorialDay',
            title: 'PSS HOLIDAY - Memorial Day',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
        {
            userName: '',
            format: 'independenceDay',
            title: 'PSS HOLIDAY - Fourth of July',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
        {
            userName: '',
            format: 'laborDay',
            title: 'PSS HOLIDAY - Labor Day',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
        {
            userName: '',
            format: 'thanksgiving',
            title: 'PSS HOLIDAY - Thanksgiving',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
        {
            userName: '',
            format: 'christmas',
            title: 'PSS HOLIDAY - Christmas',
            start: new Date(),
            end: new Date(),
            timeOffType: 'Holiday',
            timeOffDescription: 'Company holiday',
        },
    ];

    recurringEvents: RecurringEvent[] = [
        {
            userName: '',
            title: 'PAY DAY',
            start: new Date(2023, Month.JANUARY, 6),
            end: new Date(2023, Month.JANUARY, 6),
            timeOffType: 'Recurring Events',
            timeOffDescription: 'Bi-weekly payday',
            rrule: {
                freq: RRule.WEEKLY,
                byweekday: RRule.FR,
                interval: BIWEEKLY,
            },
        },
    ];

    nonShowingDays: Day[] = [
        DayOfWeekAsNumber.SATURDAY,
        DayOfWeekAsNumber.SUNDAY,
    ];

    viewPeriod: ViewPeriod;
    eventLimit = EVENTLIMIT;
    showDayPopup = false;

    constructor(
        private cdr: ChangeDetectorRef,
        public dialog: MatDialog,
        private timeOffService: TimeOffService,
        private datePipe: DatePipe,
        private themeService: ThemeService,
        private userService: UserService,
    ) {}

    getTheme$(): Observable<string> {
        return this.themeService.$theme;
    }

    getFilteredTimeOff(): void {
        this.calendarEvents = [];

        const jsonBody = {
            CurrentDate: this.viewDate.toISOString(),
            SelectedUserIds: this.selectedUsers().map(
                (user) => user.id,
            ) as string[],
        };

        this.timeOffService
            .post(['search'], jsonBody)
            .subscribe((timeOffs: TimeOff[]) => {
                timeOffs.forEach((timeOff) => {
                    const calendarEvent: CalendarEventExtension = {
                        userName: timeOff.userName,
                        id: timeOff.id,
                        start: new Date(timeOff.startDate),
                        end: new Date(timeOff.endDate),
                        title: timeOff.timeOffTitle,
                        timeOffDescription: timeOff.timeOffDescription,
                        timeOffType: timeOff.timeOffType,
                    };

                    const index: number = this.calendarEvents.findIndex(
                        (currentEvent) => calendarEvent.id === currentEvent.id,
                    );

                    if (index === NOTFOUND) {
                        this.calendarEvents.push(calendarEvent);
                    }
                });

                this.refresh.next();
            });
    }

    getHolidays(): void {
        this.allHolidays = getHolidays(this.viewDate.getFullYear());

        for (const holiday of this.psHolidays as Holiday[]) {
            const holidayData = this.allHolidays[holiday.format];
            if (holidayData) {
                const date = new Date(holidayData.date);
                const day = this.datePipe
                    .transform(date, 'EEEE')
                    ?.toUpperCase();

                if (day === DayOfWeekAsString.SUNDAY) {
                    date.setDate(date.getDate() + NEXT);
                } else if (day === DayOfWeekAsString.SATURDAY) {
                    date.setDate(date.getDate() + PREVIOUS);
                }

                const start = new Date(date);
                start.setHours(STARTOFDAYTIME, STARTOFDAYTIME, STARTOFDAYTIME);

                const end = new Date(date);
                end.setHours(ENDOFDAYHOURS, ENDOFDAYMINUTES, ENDOFDAYSECONDS);
                holiday.start = start;
                holiday.end = end;
            }
        }
    }

    updateCalendarEvents(
        viewRender:
            | CalendarMonthViewBeforeRenderEvent
            | CalendarWeekViewBeforeRenderEvent,
        forceRefresh = false,
    ): void {
        this.viewRender = viewRender;
        if (!this.viewPeriod || forceRefresh) {
            this.viewRender = viewRender;
            this.viewPeriod = viewRender.period;
            this.calendarEvents = [];
            this.getFilteredTimeOff();
            this.getHolidays();

            this.recurringEvents.forEach((event) => {
                const periodEnd = new Date(viewRender.period.end);
                periodEnd.setMonth(periodEnd.getMonth() + NEXT);

                const rule: RRule = new RRule({
                    ...event.rrule,
                    dtstart: startOfDay(event.start),
                    until: endOfDay(periodEnd),
                });

                const { timeOffType, title, timeOffDescription, userName } =
                    event;

                rule.all().forEach((date: Date) => {
                    this.calendarEvents.push({
                        userName,
                        title,
                        timeOffDescription,
                        timeOffType,
                        start: startOfDay(date),
                        end: endOfDay(date),
                    });
                });
            });

            this.psHolidays.forEach((event) => {
                this.calendarEvents.push(event);
            });

            this.closeOpenMonthViewDay();
            this.cdr.detectChanges();
        }
    }

    dayClicked(calendarEvent: { events: CalendarEvent[]; date: Date }): void {
        if (calendarEvent.events.length > 0) {
            this.dialog.open(DayDialogComponent, {
                data: { dayEvents: calendarEvent.events, date: calendarEvent.date },
                width: '550px',
                height: '500px',
            });
        }
    }

    setView(view: CalendarView): void {
        this.view = view;
    }

    closeOpenMonthViewDay(): void {
        this.activeDayIsOpen = false;
    }

    openTimeOffManager(): void {
        const dialogRef: MatDialogRef<TimeOffManagerDialogComponent> =
            this.dialog.open(TimeOffManagerDialogComponent, {
                width: '600px',
                height: '600px',
                autoFocus: false,
            });

        dialogRef.afterClosed().subscribe(() => {
            this.updateCalendarEvents(this.viewRender, true);
        });
    }

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    readonly announcer = inject(LiveAnnouncer);
    readonly currentUser = model('');
    readonly selectedUsers = signal([]);
    readonly userData = signal<User[]>([]);
    readonly filteredUsers = computed(() => {
        const currentName = this.currentUser().toLowerCase().trim();

        return this.userData()
            .filter(
                (user) =>
                    !this.selectedUsers().some(
                        (selectedUser) => selectedUser.id === user.id,
                    ),
            )
            .filter(
                (user) =>
                    !currentName ||
                    `${user.firstName} ${user.lastName}`
                        .toLowerCase()
                        .includes(currentName),
            );
    });

    ngOnInit(): void {
        const params: Map<string, number> = new Map<string, number>();
        params.set(COUNT, COUNT_ALL);

        this.userService
            .get(['timeOffUsers'], params)
            .subscribe((response: User[]) => {
                this.userData.set(
                    response.sort((a, b) =>
                        a.firstName.localeCompare(b.firstName),
                    ),
                );
            });
    }

    add(user: MatChipInputEvent): void {
        const addedUser = (user.value || '').trim();

        if (!addedUser) {
            return;
        }

        // Look for a matching user from filtered user
        const findMatchingUser: User = this.filteredUsers().find(
            (user) =>
                `${user.firstName} ${user.lastName}`.toLowerCase() ===
                addedUser.toLowerCase(),
        );

        if (findMatchingUser) {
            // Only add user if not already selected
            const currentList: User[] = this.selectedUsers();
            if (!currentList.some((user) => user.id === findMatchingUser.id)) {
                this.selectedUsers.update((users) => [
                    ...users,
                    findMatchingUser,
                ]);
            }
        }
    }

    remove(name: string): void {
        this.selectedUsers.update((users) => {
            const index = users.indexOf(name);

            if (index < 0) {
                return users;
            }

            users.splice(index, 1);
            this.announcer.announce(`Removed ${name}`);
            return [...users];
        });

        this.updateCalendarEvents(this.viewRender, true);
    }

    selected(adminUser: MatAutocompleteSelectedEvent): void {
        const user: User = adminUser.option.value;
        const currentList: User[] = this.selectedUsers();

        if (!currentList.some((existingUser) => existingUser.id === user.id)) {
            this.selectedUsers.update((users) => [...users, user]);
        }

        this.currentUser.set('');

        this.updateCalendarEvents(this.viewRender, true);
    }
}
